// src/services/voronoiCompensationRegistry.ts
class VoronoiCompensationRegistryClass {
    private data: Map<number, number> = new Map();

    set(elevation: number, averageCompensation: number) {
        this.data.set(elevation, averageCompensation);
    }

    getAverage(elevation: number): number {
        return this.data.get(elevation) ?? 0;
    }

    clear() { this.data.clear(); }
    hasData(elevation: number): boolean { return this.data.has(elevation); }
}

export const VoronoiCompensationRegistry = new VoronoiCompensationRegistryClass();